// const api = "http://localhost:4000"

const api = "https://birdiesstore.com" 
export default api